import { frontendURL } from '../../../../helper/URLHelper';
import {
  INTEGRATION_PERMISSIONS,
  WEBHOOK_PERMISSIONS,
} from 'dashboard/constants/permissions.js';
import SettingsWrapper from '../SettingsWrapper.vue';
import IntegrationHooks from './IntegrationHooks.vue';
import Index from './Index.vue';
import Webhook from './Webhooks/Index.vue';
import DashboardApps from './DashboardApps/Index.vue';
import Slack from './Slack.vue';
import Linear from './Linear.vue';
import Notion from './Notion.vue';
import Shopify from './Shopify.vue';
import GoogleCalendar from './GoogleCalendar.vue';
import LocalIntegrationSettings from './LocalIntegrationSettings.vue';

export default {
  routes: [
    {
      path: frontendURL('accounts/:accountId/settings/integrations'),
      component: SettingsWrapper,
      props: {},
      meta: {
        connectionsNavigation: true,
        connectionSection: 'integrations',
      },
      children: [
        {
          path: '',
          name: 'settings_applications',
          component: Index,
          meta: {
            permissions: ['administrator', INTEGRATION_PERMISSIONS],
            superAdminOrPermission: true,
          },
        },
        {
          path: 'dashboard_apps',
          component: DashboardApps,
          name: 'settings_integrations_dashboard_apps',
          meta: {
            permissions: ['administrator', INTEGRATION_PERMISSIONS],
          },
        },
        {
          path: 'webhook',
          component: Webhook,
          name: 'settings_integrations_webhook',
          meta: {
            permissions: ['administrator', WEBHOOK_PERMISSIONS],
          },
        },
      ],
    },
    {
      path: frontendURL('accounts/:accountId/settings/integrations'),
      component: SettingsWrapper,
      meta: {
        connectionsNavigation: true,
        connectionSection: 'integrations',
      },
      children: [
        {
          path: 'slack',
          name: 'settings_integrations_slack',
          component: Slack,
          meta: {
            permissions: ['administrator', INTEGRATION_PERMISSIONS],
          },
          props: route => ({ code: route.query.code }),
        },
        {
          path: 'linear',
          name: 'settings_integrations_linear',
          component: Linear,
          meta: {
            permissions: ['administrator', INTEGRATION_PERMISSIONS],
          },
          props: route => ({ code: route.query.code }),
        },
        {
          path: 'notion',
          name: 'settings_integrations_notion',
          component: Notion,
          meta: {
            permissions: ['administrator', INTEGRATION_PERMISSIONS],
          },
          props: route => ({ code: route.query.code }),
        },
        {
          path: 'shopify',
          name: 'settings_integrations_shopify',
          component: Shopify,
          meta: {
            permissions: ['administrator', INTEGRATION_PERMISSIONS],
          },
          props: route => ({ error: route.query.error }),
        },
        {
          path: 'google_calendar',
          name: 'settings_integrations_google_calendar',
          component: GoogleCalendar,
          meta: {
            permissions: ['administrator', INTEGRATION_PERMISSIONS],
          },
        },
        {
          path: 'email_inbox',
          name: 'settings_integrations_email_inbox',
          redirect: to => ({
            name: 'settings_inboxes_page_channel',
            params: { accountId: to.params.accountId, sub_page: 'email' },
          }),
          meta: {
            permissions: ['administrator', INTEGRATION_PERMISSIONS],
          },
        },
        {
          path: 'banking',
          name: 'settings_integrations_banking',
          component: LocalIntegrationSettings,
          meta: {
            permissions: ['administrator', INTEGRATION_PERMISSIONS],
          },
          props: { integrationId: 'banking' },
        },
        {
          path: 'erp',
          name: 'settings_integrations_erp',
          component: LocalIntegrationSettings,
          meta: {
            permissions: ['administrator', INTEGRATION_PERMISSIONS],
          },
          props: { integrationId: 'erp' },
        },
        {
          path: ':integration_id',
          name: 'settings_applications_integration',
          component: IntegrationHooks,
          meta: {
            permissions: ['administrator', INTEGRATION_PERMISSIONS],
          },
          props: route => ({
            integrationId: route.params.integration_id,
          }),
        },
      ],
    },
  ],
};
